var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#666687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4387 17.74C20.2444 17.9283 20.1552 18.2005 20.1994 18.4675L20.8662 22.1575C20.9224 22.4703 20.7904 22.7868 20.5287 22.9675C20.2722 23.155 19.9309 23.1775 19.6512 23.0275L16.3294 21.295C16.2139 21.2335 16.0857 21.2005 15.9544 21.1968H15.7512C15.6807 21.2073 15.6117 21.2298 15.5487 21.2643L12.2262 23.005C12.0619 23.0875 11.8759 23.1168 11.6937 23.0875C11.2497 23.0035 10.9534 22.5805 11.0262 22.1343L11.6937 18.4443C11.7379 18.175 11.6487 17.9013 11.4544 17.71L8.74617 15.085C8.51967 14.8653 8.44092 14.5353 8.54442 14.2375C8.64492 13.9405 8.90142 13.7238 9.21117 13.675L12.9387 13.1343C13.2222 13.105 13.4712 12.9325 13.5987 12.6775L15.2412 9.31C15.2802 9.235 15.3304 9.166 15.3912 9.1075L15.4587 9.055C15.4939 9.016 15.5344 8.98375 15.5794 8.9575L15.6612 8.9275L15.7887 8.875H16.1044C16.3864 8.90425 16.6347 9.073 16.7644 9.325L18.4287 12.6775C18.5487 12.9228 18.7819 13.093 19.0512 13.1343L22.7787 13.675C23.0937 13.72 23.3569 13.9375 23.4612 14.2375C23.5594 14.5383 23.4747 14.8683 23.2437 15.085L20.4387 17.74Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/Leaderboard.7c77180831e9ee72d7121bea2406f5e8.svg";
export { ForwardRef as ReactComponent };